import i18n from "i18next"
import { initReactI18next } from "react-i18next"

import enTranslation from "./en.json"
import frTranslation from "./fr.json"
import itTranslation from "./it.json"
import esTranslation from "./es.json"

const LANG_STORAGE_KEY = "caisse_lang"
const SUPPORTED_LANGUAGES = ["fr", "en", "it", "es"]

const normalizeLanguage = (lang) => {
    const normalized = (lang || "").toLowerCase().split("-")[0]
    return SUPPORTED_LANGUAGES.includes(normalized) ? normalized : null
}

const getWindowNameLanguage = () => {
    if (typeof window === "undefined") return null
    const prefix = "caisse_lang:"
    if (!window.name?.startsWith(prefix)) return null

    return normalizeLanguage(window.name.slice(prefix.length))
}

const getInitialLanguage = () => {
    if (typeof window === "undefined") return "fr"

    const windowNameLanguage = getWindowNameLanguage()
    if (windowNameLanguage) {
        return windowNameLanguage
    }

    const urlLanguage = normalizeLanguage(
        new URLSearchParams(window.location.search).get("lang")
    )
    if (urlLanguage) {
        return urlLanguage
    }

    const savedLanguage = window.localStorage.getItem(LANG_STORAGE_KEY)
    const normalizedSavedLanguage = normalizeLanguage(savedLanguage)
    if (normalizedSavedLanguage) {
        return normalizedSavedLanguage
    }

    return "fr"
}

const resources = {
    en: {
        translation: enTranslation,
    },
    fr: {
        translation: frTranslation,
    },
    it: {
        translation: itTranslation,
    },
    es: {
        translation: esTranslation,
    },
}

i18n.use(initReactI18next).init({
    resources,
    lng: getInitialLanguage(),
    interpolation: {
        escapeValue: false,
    },
})

i18n.on("languageChanged", (lang) => {
    if (typeof window === "undefined") return
    const normalizedLanguage = normalizeLanguage(lang)
    if (!normalizedLanguage) return

    window.localStorage.setItem(LANG_STORAGE_KEY, normalizedLanguage)
})

export default i18n
